import useAuth from "./useAuth";

const defaultExperimentalFeatures: string[] = [];

export const useExperimental = () => {
    const { user } = useAuth();
    const experimentalFeatures: string[] = user?.experimental_features ?? defaultExperimentalFeatures;
    return experimentalFeatures;
};
